import { apiClient } from '../../apiHelper';

/** Raw DICOMweb metadata JSON (array of tag objects or single object). */
export type DicomwebMetadataJson = unknown;

const rsBase = 'dcm4chee-arc/aets/DCM4CHEE/rs';

export async function fetchSeriesMetadata(
  studyUID: string,
  seriesUID: string
): Promise<DicomwebMetadataJson> {
  return apiClient.get(
    `${rsBase}/studies/${encodeURIComponent(studyUID)}/series/${encodeURIComponent(seriesUID)}/metadata`
  );
}

export async function fetchInstanceMetadata(
  studyUID: string,
  seriesUID: string,
  instanceUID: string
): Promise<DicomwebMetadataJson> {
  return apiClient.get(
    `${rsBase}/studies/${encodeURIComponent(studyUID)}/series/${encodeURIComponent(seriesUID)}/instances/${encodeURIComponent(instanceUID)}/metadata`
  );
}
